"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseButton = void 0;
var _hooks = require("../../../../hooks");
var _A = require("../../../../UI/A");
var _Icon = require("../../../../UI/Icon");
var _Header = require("../Header.labels");
var _jsxRuntime = require("react/jsx-runtime");
const PurchaseButton = props => {
  const {
    isMobileView,
    user,
    purchaseButtonGuestLabel,
    purchaseButtonGuestHref = '',
    purchaseButtonLabel,
    purchaseButtonHref = ''
  } = props;
  const getLabel = (0, _hooks.useLabels)({
    labels: _Header.labels
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    style: {
      paddingInlineEnd: '12px'
    },
    children: isMobileView && !user?.userId ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
      to: getLabel('home_purchase_link'),
      target: "_blank",
      shape: "roundedRectangle",
      color: "basic",
      isBtnView: true,
      view: "text",
      category: "upperToolbar",
      label: "purchase",
      ariaLabel: getLabel('home_page_subscription'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        name: "Store",
        width: "20",
        height: "20"
      })
    }) : !isMobileView && (user?.userId ? purchaseButtonLabel : purchaseButtonGuestLabel) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
      to: user?.userId ? purchaseButtonHref : purchaseButtonGuestHref,
      target: "_blank",
      shape: "roundedRectangle",
      color: "primary",
      isBtnView: true,
      view: "contained",
      category: "upperToolbar",
      label: "purchase",
      ariaLabel: user?.userId ? purchaseButtonLabel : purchaseButtonGuestLabel,
      children: user?.userId ? purchaseButtonLabel : purchaseButtonGuestLabel
    })
  });
};
exports.PurchaseButton = PurchaseButton;